import { format, parseISO } from "date-fns";

/** Format ISO date string for display */
export const formatDate = (dateStr, pattern = "dd MMM yyyy") => {
  if (!dateStr) return "-";
  try {
    return format(parseISO(dateStr), pattern);
  } catch {
    return dateStr;
  }
};

/** Format currency */
export const formatCurrency = (amount, currency = "INR") =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency }).format(
    amount ?? 0
  );

/** Truncate string */
export const truncate = (str, length = 50) =>
  str?.length > length ? `${str.slice(0, length)}…` : str;

/** Generate initials from full name */
export const getInitials = (name = "") =>
  name
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

/** Debounce function */
export const debounce = (fn, delay = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
};

/** Build query string from object */
export const buildQueryString = (params = {}) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return qs ? `?${qs}` : "";
};

/** Status badge color helper */
export const statusBadgeClass = (status) => {
  const map = {
    active: "badge-success",
    approved: "badge-success",
    confirmed: "badge-success",
    pending: "badge-warning",
    rejected: "badge-danger",
    cancelled: "badge-danger",
    blocked: "badge-danger",
    completed: "badge-info",
  };
  return map[status?.toLowerCase()] || "badge-info";
};
